<script setup lang="ts">
import { Dialog, DialogActions, DialogBody, DialogDescription, DialogTitle, Sheet, SheetActions, SheetBody, SheetDescription, SheetTitle } from 'catalyst-vue'
import { useLibraryLayout } from '../../lib/library-layout'

const props = withDefaults(defineProps<{ open: boolean; title: string; description: string; pending?: boolean; size?: 'lg' | 'xl' | '2xl' | '3xl' }>(), { pending: false, size: 'lg' })
const emit = defineEmits<{ close: [] }>()
const compact = useLibraryLayout()
</script>

<template>
  <component :is="compact ? Sheet : Dialog" :open="open" :close-on-outside-click="!pending" :size="compact ? undefined : props.size" class="library-overlay" :class="{ 'is-compact': compact }" @close="!pending && emit('close')">
    <div class="library-overlay-heading">
      <component :is="compact ? SheetTitle : DialogTitle">{{ title }}</component>
      <component :is="compact ? SheetDescription : DialogDescription">{{ description }}</component>
    </div>
    <component :is="compact ? SheetBody : DialogBody" class="library-overlay-body"><slot /></component>
    <component :is="compact ? SheetActions : DialogActions" class="library-overlay-actions"><slot name="actions" /></component>
  </component>
</template>
